import { render, staticRenderFns } from "./AddChallengePartner.vue?vue&type=template&id=427e33ef&"
import script from "./AddChallengePartner.vue?vue&type=script&lang=js&"
export * from "./AddChallengePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports